import fileHttp from "@/http/requests/file"
import state from '@/store/state'
import axios from 'axios'

export const replaceAll = (string, from, to) => {
  const stringLength = string.length
  let position = 0
  while (position < stringLength) {
    string = string.replace(from, to)
    position++
  }

  return string
}

export const moneyToFloat = (money) => {
  money = money.toString().replace('R$ ', '')
  money = replaceAll(replaceAll(money, ',', ''), '.', '')

  const unitPosition = money.length - 2
  money = parseFloat([
    money.slice(0, unitPosition),
    '.',
    money.slice(unitPosition)
  ].join(''))

  return money
}

export const b64DecodeUnicode = (str) => {
    return decodeURIComponent(atob(str).split('').map(function(c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));
}

export const formatTenantPath = (string) => {
  return string
}

export const getBaseUrl = () => {
  return process.env.VUE_APP_BASE_URL;
}

export const getCurrentTenant = () => {
  return window.location.href.replace(process.env.VUE_APP_BASE_URL, '').split('/')[0];
}

export const formatRouteTenantPath = (route) => {
  return route;
}

export const isOriginalBackoffice = () => {
  return window.location.href.includes('backoffice.pedbot')
}

export const encodeToBase64 = content => {
  return btoa(unescape(encodeURIComponent(content)))
}

export const decodeFromBase64 = content => {
  return decodeURIComponent(escape(atob(content)))
}

export const parseItemFromObjectToString = (index, item, isLastItem) => {
  if (typeof item === 'object') {
      item = index + ` { ` + parseObjectToString(item) + ` }`;
  }

  return item + (isLastItem ? '' : ', ');
}

export const removeFileFromBucket = (fileUrl) => {
  const urlArray = fileUrl.split("/");
  const filename = urlArray[urlArray.length - 1]

  const headers = {
    Authorization: 'Bearer ' + state.auth.bearer
  }

  return fileHttp
    .delete(filename, headers)
    .catch(err => {
      console.error(err)
    })
}

export const parseObjectToString = (object) => {
  let objectString = ''

  const objectIndexes = Object.keys(object)
  const objectValues = Object.values(object)

  for (const [index, item] of Object.entries(object)) {
    objectString += parseItemFromObjectToString(
      index,
      item,
      (
        objectIndexes[objectIndexes.length - 1] === index &&
        objectIndexes[objectValues.length - 1] === item
      )
    )
  }

  return objectString
}

export const parseParamToString = (item, value) => {
  if (typeof value === 'string') {
      return item + `: "` + value + `", `;
  }

  return item + `: ` + value + ', ';
}

export const parseObjectParamsToString = (params) => {
  if (Object.keys(params).length === 0) {
      return '';
  }

  let objectString = '';

  for (const [index, item] of Object.entries(params)) {
    objectString += parseParamToString(index, item);
  }

  return ` ( ` + objectString + ` )`;
}

export const formatGraphqlBody = (type, functionName, responseItems, params = {}) => {
  const responseItemsString = parseObjectToString(responseItems)
  const paramsItemsString = parseObjectParamsToString(params)

  return { query:  type + " { " + functionName + paramsItemsString + " { " + responseItemsString + " } } " }
}

export const formatGraphqlParams = (params) => {
  const formatedParams = {}
  for (const [index, item] of Object.entries(params)) {
    if (item !== '' && item !== null && item !== undefined) {
      formatedParams[index] = item
    }
  }

  return formatedParams
}

export const formatDate = (date) => {
  if (date === null || date === '') {
    return {
      day: '',
      month: '',
      year: '',
      hour: '',
      minute: '',
      second: '',
      full: '',
      date_only: ''
    };
  }

  const d = new Date(date);

  let day = d.getDate();
  let month = d.getMonth() + 1;
  const year = d.getFullYear();
  let hour = d.getHours();
  let minute = d.getMinutes();
  let second = d.getSeconds();

  if (day < 10) { day = `0${day}`; }
  if (month < 10) { month = `0${month}`; }
  if (hour < 10) { hour = `0${hour}`; }
  if (minute < 10) { minute = `0${minute}`; }
  if (second < 10) { second = `0${second}`; }

  return {
    day,
    month,
    year,
    hour,
    minute,
    second,
    full: `${day}/${month}/${year} ${hour}:${minute}:${second}`,
    date_only: `${day}/${month}/${year}`
  }
}

export const parsePhoneNumber = (phoneNumber) => {
  const parsedNumber = phoneNumber.toString().replace(/[^0-9.]+/gi, '')
  const hasCountryCode = parsedNumber.substr(0, 2) === "55"
  return hasCountryCode
    ? (parsedNumber.length <= 11 ? `55${parsedNumber}` : parsedNumber)
    : `55${parsedNumber}`
}

export const maskPhoneNumberToBrazilian = (phoneNumber) => {
  /**
   * If the phone number is in the old format: (XX) XXXXX-XXXX,
   * it'll be replaced to 55XXXXXXXXXXX
   */
  phoneNumber = parsePhoneNumber(phoneNumber);

  const phoneLength = phoneNumber.length;
  const ddd = phoneNumber.substr(2, 2);
  const prefix = phoneNumber.substr(4, phoneLength === 12 ? 4 : 5);
  const suffix = phoneNumber.substr(phoneLength - 4, 4);

  return `(${ddd}) ${prefix}-${suffix}`;
}

export const hostIsBeta = () => window.location.host.includes('beta');

export const formatTenantLabel = (tenant) => {
  return tenant.fqdn ? tenant.fqdn.split('.')[0] : tenant.id;
}

export const filterTenantsByHost = (items = []) => {
  if (hostIsBeta()) {
    return items.filter(item => !!item.is_beta);
  }
  return items.filter(item => item.is_beta === false);
}

export const tenantLabel = (map, id) => {
  if (!id) return '-';
  const found = map ? map[id] : null;
  return found || `ID ${id}`;
}

export const approvalStatusLabel = (status) => {
  const map = {
    pending: 'Pendente',
    approved: 'Aprovado',
    rejected: 'Recusado',
    canceled: 'Cancelado',
    executed: 'Executado',
    failed: 'Falhou'
  };
  return map[status] || status;
}

export const approvalStatusColor = (status) => {
  const map = {
    pending: 'warning',
    approved: 'success',
    rejected: 'danger',
    canceled: 'dark',
    executed: 'success',
    failed: 'danger'
  };
  return map[status] || 'primary';
}

export const getChatOptionAsTreeChild = (chatOption, useNode = false, allExpanded = false, lastOpen = null) => {
  if (useNode) {
    return {
      title: chatOption.title,
      is_close: chatOption.is_close,
      finish_ticket: chatOption.finish_ticket,
      expanded: allExpanded,
      type: chatOption.type,
      children: chatOption.children,
      priority: chatOption.priority,
      image_url: chatOption.image_url,
      redirect_url: chatOption.redirect_url,
      document_name: chatOption.document_name,
      is_interactive: chatOption.is_interactive,
      lenght: chatOption.description ? chatOption.description.trim().length : 0,
      userDepartment: chatOption.userDepartment ? chatOption.userDepartment.id : null,
      group: chatOption.group ? chatOption.group.id : null,
      reasonOption: chatOption.reasonOption ? chatOption.reasonOption.id : null,
      reason: chatOption.reasonOption ? chatOption.reasonOption.reason_id : null ? chatOption.children.map(option => getChatOptionAsTreeChild(option, true, true)) : []
    }
  }

  return {
    title:
      `${chatOption.id}`
      +`|${chatOption.number}`
      +`|${chatOption.userDepartment ? chatOption.userDepartment.id : ''}`
      +`|${chatOption.priority !== null && chatOption.priority !== undefined && chatOption.priority !== '' ? chatOption.priority : ''}`
      +`|${chatOption.finish_ticket !== null && chatOption.finish_ticket !== undefined ? chatOption.finish_ticket : false}`
      +`|${chatOption.number !== null && chatOption.number !== undefined && chatOption.number !== '' ? chatOption.number + ' - ' : ''}`
      + `${chatOption.description}`,
    expanded: !!lastOpen.includes(chatOption.id),
    is_close: chatOption.is_close,
    finish_ticket: chatOption.finish_ticket,
    type: chatOption.type,
    image_url: chatOption.image_url,
    redirect_url: chatOption.redirect_url,
    document_name: chatOption.document_name,
    is_interactive: chatOption.is_interactive,
    lenght: chatOption.description ? chatOption.description.trim().length : 0,
    group: chatOption.group ? chatOption.group.id : null,
    reasonOption: chatOption.reasonOption ? chatOption.reasonOption.id : null,
    reason: chatOption.reasonOption ? chatOption.reasonOption.reason_id : null,
    children: chatOption.childOptions ? chatOption.childOptions.map(option => getChatOptionAsTreeChild(option, false, false, lastOpen)) : []
  }
}

export const getOptionDataFromNodeTitle = (nodeTitle, parent) => {
  const optionId = parseInt(nodeTitle.substr(0, nodeTitle.indexOf('|')));
  nodeTitle = nodeTitle.replace(`${optionId}|`, '')

  let optionNumber = nodeTitle.substr(0, nodeTitle.indexOf('|'));
  nodeTitle = nodeTitle.replace(`${optionNumber}|`, '')
  optionNumber = parseInt(optionNumber)

  let departmentId = nodeTitle.substr(0, nodeTitle.indexOf('|'));
  nodeTitle = nodeTitle.replace(`${departmentId}|`, '')
  departmentId = parseInt(departmentId)

  let priority = nodeTitle.substr(0, nodeTitle.indexOf('|'));
  nodeTitle = nodeTitle.replace(`${priority}|`, '')
  priority = parseInt(priority)

  let finishTicket = nodeTitle.substr(0, nodeTitle.indexOf('|'));
  nodeTitle = nodeTitle.replace(`${finishTicket}|`, '')
  finishTicket = finishTicket === 'true';

  let parentId;

  if (parent) {
    const parentTitle = parent.title
    parentId = parseInt(parentTitle.substr(0, parentTitle.indexOf('|')));
  }

  return {
    optionId,
    optionNumber,
    parentId,
    departmentId,
    priority,
    finishTicket,
    newNodeTitle: nodeTitle
  }
}

export const hasPermission = (permissionName) => {
  const permissions = !state.global.permissionRoutes.length ? JSON.parse(localStorage.getItem('permissionRoutes')) : state.global.permissionRoutes;
  if (permissions) {
    return permissions.indexOf(permissionName) !== -1;
  }

  return false
}

export const lowerCaseFirstLetter = (string) => {
  return string.charAt(0).toLowerCase() + string.slice(1);
}

export const delay = async (ms) => {
    return new Promise(resolve => setTimeout(() => resolve(), ms));
};

export const hasPermissionBackOffice = (permissionName) => {
  if (!permissionName) return false;

  const routes = !state.global.permissionRoutes.length ? JSON.parse(localStorage.getItem('permissionRoutes')) : state.global.permissionRoutes;
  if (routes && routes.length) {
    return routes.includes(permissionName);
  }

  let permissions = state.permission.permissions;
  if (!permissions.length) {
    permissions = JSON.parse(localStorage.getItem('permissions')) || [];
  }

  return permissions.some(permission => permission.route_name === permissionName);
}

export const canSeeSensitiveReportDataBackOffice = () => {
  return hasPermissionBackOffice('reports-sensitive-data');
}

export const availablePlans = () => {
  return [
    {
      value: 'BASIC',
      text: 'Basico'
    },
    {
      value: 'MEDIUM',
      text: 'Médio'
    },
    {
      value: 'ADVANCED',
      text: 'Avançado'
    },
    {
      value: 'EXPERT',
      text: 'Expert'
    },
    {
      value: 'ON-DEMAND',
      text: 'Sob Demanda'
    }
  ]
};


export const formatTemplatePlaceholder = (value) => {
  return `{{${value}}}`;
}

export const massCampaignStatusColor = (status) => {
  const map = {
    validated: 'warning',
    queued: 'primary',
    running: 'primary',
    success: 'success',
    completed: 'success',
    completed_with_errors: 'warning',
    failed: 'danger',
    skipped: 'dark',
  };

  return map[status] || 'primary';
}

export const detectMediaFormatFromUrl = (url) => {
  const value = `${url || ''}`.trim();
  if (!value) {
    return null;
  }

  if (value.toLowerCase().startsWith('data:image/')) {
    return 'IMAGE';
  }

  if (value.toLowerCase().startsWith('data:video/')) {
    return 'VIDEO';
  }

  if (value.toLowerCase().startsWith('data:')) {
    return 'DOCUMENT';
  }

  let extension = '';
  try {
    const normalized = value.includes('://') ? value : `https://local/${value.replace(/^\/+/, '')}`;
    const path = new URL(normalized).pathname || '';
    const split = path.split('.');
    extension = split.length > 1 ? `${split.pop() || ''}`.toLowerCase() : '';
  } catch (error) {
    const sanitized = value.split('?')[0].split('#')[0];
    const split = sanitized.split('.');
    extension = split.length > 1 ? `${split.pop() || ''}`.toLowerCase() : '';
  }

  if (!extension) {
    return null;
  }

  const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'webp', 'bmp', 'jfif', 'tif', 'tiff'];
  const videoExtensions = ['mp4', 'mov', 'avi', 'mkv', 'webm', 'mpeg', 'mpg', '3gp'];
  const documentExtensions = ['pdf', 'doc', 'docx', 'txt', 'csv', 'xls', 'xlsx', 'ppt', 'pptx'];

  if (imageExtensions.includes(extension)) {
    return 'IMAGE';
  }

  if (videoExtensions.includes(extension)) {
    return 'VIDEO';
  }

  if (documentExtensions.includes(extension)) {
    return 'DOCUMENT';
  }

  return 'DOCUMENT';
}

export const normalizeMassCampaignErrorText = (value) => {
  const text = `${value || ''}`.trim();
  if (!text) {
    return '';
  }

  return text
    .replace(/\\u([0-9a-fA-F]{4})/g, (_, code) => String.fromCharCode(parseInt(code, 16)))
    .replace(/\\\//g, '/')
    .replace(/\\n/g, '\n')
    .replace(/\\r/g, '\r')
    .replace(/\\t/g, '\t')
    .replace(/\s+\|\s+/g, ' | ')
    .trim();
}

const tryParseJsonString = (value) => {
  const text = `${value || ''}`.trim();
  if (!text) {
    return null;
  }

  if (text[0] !== '{' && text[0] !== '[') {
    return null;
  }

  try {
    return JSON.parse(text);
  } catch (error) {
    return null;
  }
}

const extractErrorLocation = (locationSource) => {
  if (!locationSource) {
    return null;
  }

  const location = Array.isArray(locationSource) ? locationSource[0] : locationSource;
  if (!location || typeof location !== 'object') {
    return null;
  }

  const file = `${location.file || location.path || ''}`.trim();
  const line = location.line;

  if (!file && (line === null || line === undefined || `${line}`.trim() === '')) {
    return null;
  }

  const compactFile = file
    .split('/')
    .filter(Boolean)
    .slice(-2)
    .join('/');

  if (line === null || line === undefined || `${line}`.trim() === '') {
    return compactFile || file || null;
  }

  return `${compactFile || file || '-'}:${line}`;
}

const summarizeErrorText = (value) => {
  const text = normalizeMassCampaignErrorText(value);
  if (!text) {
    return '-';
  }

  const lines = text.split('\n').map((line) => line.trim()).filter(Boolean);
  const firstLine = lines.length ? lines[0] : text;

  if (firstLine.length <= 220) {
    return firstLine;
  }

  return `${firstLine.slice(0, 217)}...`;
}

const buildFallbackSummary = (code, location) => {
  if (code && location) {
    return `Erro da API (cód. ${code} em ${location}).`;
  }

  if (code) {
    return `Erro da API (cód. ${code}).`;
  }

  if (location) {
    return `Erro da API (${location}).`;
  }

  return 'Erro ao processar a campanha.';
}

const normalizeSummaryOutput = (summary, code, location) => {
  const value = `${summary || ''}`.trim();
  if (!value || value === '-' || value === '{' || value === '[') {
    return buildFallbackSummary(code, location);
  }

  return value;
}

const toPrettyJson = (value) => {
  try {
    return JSON.stringify(value, null, 2);
  } catch (error) {
    return `${value || ''}`;
  }
}

export const parseMassCampaignError = (errorMessage) => {
  const normalized = normalizeMassCampaignErrorText(errorMessage);
  if (!normalized) {
    return {
      hasError: false,
      summary: '-',
      code: null,
      location: null,
      detail: null,
      raw: '',
    };
  }

  const parsed = tryParseJsonString(normalized);
  if (parsed && Array.isArray(parsed.errors) && parsed.errors.length) {
    const firstError = parsed.errors[0] || {};
    const code = firstError.code === null || firstError.code === undefined ? null : `${firstError.code}`;
    const location = extractErrorLocation(firstError.locations || firstError.location);
    const primaryMessage = normalizeMassCampaignErrorText(firstError.message || parsed.message || '');
    const summary = normalizeSummaryOutput(summarizeErrorText(primaryMessage), code, location);

    return {
      hasError: true,
      summary,
      code,
      location,
      detail: toPrettyJson(parsed),
      raw: normalized,
    };
  }

  if (parsed && typeof parsed === 'object') {
    const nestedError = parsed.error && typeof parsed.error === 'object' ? parsed.error : null;
    const nestedTrace = nestedError && Array.isArray(nestedError.trace) && nestedError.trace.length
      ? nestedError.trace[0]
      : null;

    const code = parsed.code !== null && parsed.code !== undefined
      ? `${parsed.code}`
      : (nestedError && nestedError.code !== null && nestedError.code !== undefined ? `${nestedError.code}` : null);
    const location = extractErrorLocation(
      parsed.locations
      || (nestedError && nestedError.locations)
      || nestedTrace
    );
    const messageCandidate = normalizeMassCampaignErrorText(
      parsed.message
      || (nestedError && nestedError.message)
      || ''
    );
    const summary = normalizeSummaryOutput(summarizeErrorText(messageCandidate), code, location);

    return {
      hasError: true,
      summary,
      code,
      location,
      detail: toPrettyJson(parsed),
      raw: normalized,
    };
  }

  const summary = normalizeSummaryOutput(summarizeErrorText(normalized), null, null);
  const hasDetail = normalized.length > summary.length || normalized.includes('\n') || normalized.includes('{');

  return {
    hasError: true,
    summary,
    code: null,
    location: null,
    detail: hasDetail ? normalized : null,
    raw: normalized,
  };
}

export const filterPassword = (password) => {
  const weak = 50;
  const average = 75;
  const strong = 100;

  if (/(\w)\1{2,}/.test(password)) {
    return weak;
  }
  if (/(\d)\1{2,}/.test(password)) {
    return weak;
  }
  if (/(?:012|123|234|345|456|567|678|789|890|abc|bcd|cde|def|efg|fgh|ghi|hij|ijk|jkl|klm|lmn|mno|nop|opq|pqr|qrs|rst|stu|tuv|uvw|vwx|wxy|xyz)/i.test(password)) {
    return weak;
  }
  if (password.length < 8) {
    return weak;
  }
  if (!/[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]+/.test(password) || !/(?=(.*?[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]){2})/.test(password)) {
    return average;
  }
  if (!/(?=.*[a-z])(?=.*[A-Z])/.test(password)) {
    return average;
  }
  return strong;
}

export const getIp = async () => {
  try {
    const response = await axios.get('https://api.ipify.org?format=json');
    const ip = response.data.ip;
    return ip;
  } catch (error) {
    console.error('Erro ao obter o endereço IP:', error);
    return null;
  }
}

export const empty = (value) => {
  return (
    value === undefined ||
    value === null      ||
    value === false     ||
    value === ''        ||
    value === 0         ||
    (Array.isArray(value) && value.length === 0) ||
    (typeof value === 'object' && Object.keys(value).length === 0)
  );
}
